/* eslint-disable max-len */
// ==============================================
// ==================Import======================
// ==============================================

// ==================Style&IMG===================
import './style.scss';

// =================Material UI==================
import {
  Backdrop,
  Box,
  Fade,
  Modal,
  Typography,
} from '@mui/material';

// =================React Hook==================
import { useSelector, useDispatch } from 'react-redux';

// =================Actions==================
import { setModalErrCo } from '../../actions/multipleMetadata';

function ModalErrCo() {
// ==================HOOK=========================
  const dispatch = useDispatch();
  const openModalErrCo = useSelector(
    (state) => state.multipleMetadata.modalErrCo,
  );
  const errorCode = useSelector((state) => state.multipleMetadata.errorCode);
  const statusCode = useSelector((state) => state.multipleMetadata.statusCode);
  // ==================handler=========================
  const handleCloseModalErrCo = () => {
    dispatch(setModalErrCo(false));
  };

  return (
    <Modal
      open={openModalErrCo}
      onClose={handleCloseModalErrCo}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 600,
        },
      }}
    >
      <Fade in={openModalErrCo}>
        <Box className="commandLineClient--modal">
          <Typography id="modal-modal-title" variant="h4" component="h2">
            No response from API
          </Typography>
          <Box className="commandLineClient--modal__text">
            <p>
              Connection Error
            </p>
            <p>
              error code: <code>{errorCode}</code>
            </p>
            <p>
              status code: <code>{statusCode}</code>
            </p>
            <div className="commandLineClient--modal__text--button">
              {/* <button className="commandLineClient--modal__text--button__close" type="button" onClick={handleCloseCommandLineClientModal}>Close</button> */}
              <button className="commandLineClient--modal__text--button__close--window" type="button" onClick={handleCloseModalErrCo}>Close the modal</button>
            </div>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}

export default ModalErrCo;
